import { Component, OnInit } from '@angular/core';
import * as $ from "jquery";

import { ModulesService } from "../../modules/modules.service";
import { DepartmentsService } from "../../departments/departments.service";
import { CommonService} from '../../services/common.service';
import { Subscription } from 'rxjs/Subscription';
@Component({
  selector: 'app-sidebar',
  providers: [ModulesService, DepartmentsService],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

  language :any;
  modules: any = [];
  busy: Promise<any>;
  staticLinks: any = [];
  MiscellaneousDepartmentTypes = [];

  isAdmin: any = false;
  permissions: any;
private subscription: Subscription;

  constructor(
    private modulesService: ModulesService,
    private departmentsService: DepartmentsService,
    private commonService: CommonService
  ) { }

  ngOnInit() {
    this.language = 'en';

    this.permissions = JSON.parse(localStorage.getItem('permissions'));

    this.isAdmin = localStorage.getItem('isAdmin') === 'true';
    this.getDepartments();
    if(this.isAdmin)
      this.getStaticLinks();

    this.MiscellaneousDepartmentTypes = [ 'maintenance_request', 'link', 'sharing'];

    // this.subscription = this.commonService.notifyObservable$.subscribe((res) => {
    //         console.log('print----',res);
    //         console.log('this.staticLinks  ',this.staticLinks)
    //           if (res.hasOwnProperty('option') && res.option === 'module-toggle' &&  res.module !=undefined) {

    //             //this.getDepartments();
    //              //if(this.isAdmin)
    //              this.staticLinks.forEach(function (item) {
    //               if(item.name==res.module  ){
    //                 item.is_active=res.is_active;
    //                 item.link=res.is_active?['/departments/', res.module_id]:[];
    //               }
    //              })
    //           }

    //           if (res.hasOwnProperty('option') && res.option === 'department-toggle') {

    //             //this.getDepartments();
    //              //if(this.isAdmin)
    //              this.staticLinks.forEach(module=> {
    //               if(module._id==res.department.module_id  ){
    //                 module._childs.forEach(child=> {
    //                   if(child._id === res.department._id)
    //                   child.is_active = res.department.is_active
    //                   console.log('this.staticLinks  ',this.staticLinks)
    //                 })

    //               }

    //              });
    //           }

    //         });
  }

  getItems(departments) {
    this.modules = [];
    let _tmpModules = {};
    let _tmpDepartments = {};
    this.modulesService.getItems(this.language, 'listActiveModulesForWeb').then((res) => {
      this.modules = res.data.filter(item => item.view_type == "subCell" || item.view_type == "subModule" || item.view_type == "dashboardModule");


      let queryParams = {};
      this.modules.forEach((module) => {

        let _departments = departments.filter(item => item._id == module._id)[0].departments;
        if(this.isAdmin)
        _tmpModules[module._id] = module.name;
        else
        if(this.permissions[module._id].manage_orders)
        _tmpModules[module._id] = module.name;


        _departments.forEach((dept) => {
          if(dept.is_deleted == false) {
            _tmpDepartments[dept._id] = { name: dept.name.en, module_id: dept.module_id, type: dept.department_type }
          }
        });

        let _childs = null;
        if(this.isAdmin){
          _childs = _departments.filter(itm => this.MiscellaneousDepartmentTypes.indexOf(itm.department_type) == -1 && itm.is_deleted === false);
        }else if(this.permissions[module._id].staff_admin !=undefined && this.permissions[module._id].staff_admin==true){
          _childs = _departments.filter(itm => this.MiscellaneousDepartmentTypes.indexOf(itm.department_type) == -1 && itm.is_deleted === false
          && this.permissions[module._id].departments.indexOf(itm._id)>=0);
        }


        if(this.isAdmin || (this.permissions[module._id] != undefined)) {

          let _url =  (this.permissions[module._id].manage_orders  || this.isAdmin) ?['/departments/', module._id]:[];
          if(module.view_type == "subModule") {
            if(this.permissions[module._id].manage_orders ||  this.isAdmin){
              _url = module.admin_url.split("/")
              _url = _url.length == 1 ? ["/", module.admin_url] : ["/" +_url[0], _url[1]]
             // queryParams = {m_id:module._id};
            }else{
              _url = []
            }
          }else{
            queryParams = {};
          }
          if(module.view_type!="dashboardModule"){
            this.staticLinks.push({
            name: module.name,
            _id:module._id,
            is_active:module.is_active,
            link: _url,
           // query_params:queryParams,
            view_type:module.view_type,
            exact:(module.exact)?true:false,
            icon: (module.icon ? module.icon : 'fa-sitemap'),
            childs: _childs,
            module_permission:this.permissions[module._id].manage_orders
          });
          }
          
        }
      });
      localStorage.setItem('modules', JSON.stringify(_tmpModules));
      localStorage.setItem('departments', JSON.stringify(_tmpDepartments));

    }).catch((res) => { });
  }


  getDepartments() {
    this.modules = [];
    this.departmentsService.getDepartments().then((res) => {
      this.getItems(res.data);
    });
  }

  getStaticLinks() {
    this.staticLinks = [
      // { name: 'Users', link: '/clients', icon: 'fa-users' },
      // { name: 'Staff Members', link: '/staff', icon: 'fa-users' },
      // { name: 'Roles and Permissions', link: '/roles', icon: 'fa-key' },
      // { name: 'Profile Questions', link: '/questions', icon: 'fa-question-circle' },
      // { name: 'Modules', link: '/modules', icon: 'fa-sitemap' },
      // { name: 'Email Templates', link: '/email-templates', icon: 'fa-envelope' },
      // { name: 'Categories', link: '/categories', icon: 'fa-sitemap' },
      // { name: 'Admin Settings', link: '/admin-settings', icon: 'fa-sitemap' },
      // { name: 'Contact Requests', link: '/stay-contacts', icon: 'fa-address-book' }
      // { name: 'Local Attractions Requests', link: '/local-attractions/requests', icon: 'fa-sitemap' }

      // { name: 'Modifiers', link: '/modifier', icon: 'fa-sitemap' },
     // { name: 'Activity Logs', link: '/logs', icon: 'fa-sitemap' },
      //{ name: 'Manage Notifications', link: '/manage-notifications', icon: 'fa-sitemap' }
    ];
  }

}



// WEBPACK FOOTER //
// C:/Users/Home/OneDrive/Documents/hotellife_web/src/app/theme/sidebar/sidebar.component.ts